// extracted by mini-css-extract-plugin
module.exports = {"popupCore":"ApiRequestTemplatePopup_popupCore__2gIT-","downloadButton":"ApiRequestTemplatePopup_downloadButton__1ku6G"};